import React from 'react';
import pourquoiSimulationImages from '../../../assets/images/pourquoiSimulationImages.png'
import { useSelector } from 'react-redux';
import { langSelector } from '../../../store/langSlice';
import { getLang } from '../../../environnement';

export default function PourquoiSimulation() {
  const lang = useSelector(langSelector);

  return (
    <div className='w-full bg-primary px-5 xxs:px-10 py-10 flex justify-center' style={{transform: lang === 'ar' ? 'scaleX(-1)' : 'none'}}>
      <div className='w-[1200px] flex flex-col items-center lg:flex-row justify-around'>
        <img src={pourquoiSimulationImages} alt='pourquoi simulation images' className='w-[520px] xl:w-[600px]'/>
        <div className='flex flex-col justify-center mt-10 lg:mt-0' style={{transform: lang === 'ar' ? 'scaleX(-1)' : 'none', direction: lang === 'ar' ? 'rtl' : 'ltr'}}>
          <p className={`text-white font-medium text-2xl xxs:text-3xl xl:text-4xl mb-10 lg:w-[350px] xl:w-[450px] ${lang === 'ar' ? 'text-center lg:text-end' : 'text-center lg:text-start'}`}>{getLang(lang).accueil.commentSimulationPeutAider}</p>
          <p className={`text-white font-regular text-xl xxs:text-2xl xl:text-3xl mb-5 ${lang !== 'ar' && 'lg:w-[350px] xl:w-[400px]'} ${lang === 'ar' ? 'text-center lg:text-end' : 'text-center lg:text-start'}`}>{getLang(lang).accueil.developpezCompetence}</p>
          <p className={`text-white font-regular text-xl xxs:text-2xl xl:text-3xl mb-5 ${lang !== 'ar' && 'lg:w-[350px] xl:w-[400px]'} ${lang === 'ar' ? 'text-center lg:text-end' : 'text-center lg:text-start'}`}>{getLang(lang).accueil.experienceApprentissage}</p>
          <p className={`text-white font-regular text-xl xxs:text-2xl xl:text-3xl ${lang !== 'ar' && 'lg:w-[350px] xl:w-[400px]'} ${lang === 'ar' ? 'text-center lg:text-end' : 'text-center lg:text-start'}`}>{getLang(lang).accueil.encouragezInteractivite}</p>
        </div>
      </div>
    </div>
  );
}
